import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from 'react-spinners';
import Skeleton from 'react-loading-skeleton'
import { Table } from "antd";
import { adminMainUrl } from '../../Config.jsx';
import { getCustomerProfileDocumentList } from "../../Redux/action/Admin/CustomerAction.js";
import Pagination from "../../Admin/Masters/Pagination.jsx";
import axios from "axios";
import DisapprovedDocUpload from "./DisapprovedDocUpload.jsx";
import RejectionAlert from "../Dashboard/RejectionAlert.jsx";



const CustomerProfileDocumentationList = ({ CustomerProfileData }) => {

  const { b64id } = useParams();
  const navigate = useNavigate()
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const token = Cookies.get("customertoken");

  const [currentData, setCurrentData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [dataOffset, setDataOffset] = useState(0);

  const dataPerPage = 10;
  const [reload, setReload] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [disable, setDisable] = useState(false)

  // const { name } = useParams();
  const dispatch = useDispatch();
  const {
    loadingCustomerProfileDocumentListApi,
    CustomerProfileDocumentListError,
    CustomerProfileDocumentList,

  } = useSelector((state) => state?.CustomerReducer);
  useEffect(() => {
    dispatch(getCustomerProfileDocumentList());
  }, [token]);

  const isValidJson = (str) => {
    try {

      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };
  const handleSuccess = () => {
    // Toggle reload to trigger useEffect
    setReload((prev) => !prev);
  };
  const [id, setid] = useState(null)
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = (id) => {
    setid(id)
    setAddShow(true);
  };



  const [grid, setGrid] = useState(true)
  const arr = new Array(5).fill(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }

  const handleChange = async (e, id) => {
    console.log(e.target.files[0]);
    setDisable(true)
    try {
      const token = Cookies.get('customertoken');

      // Create FormData instance and append the file
      let formData = new FormData();
      formData.append('image', e.target.files[0]);
      formData.append('document_id', id);

      let config = {
        headers: {
          "auth-token": token,
          'Content-Type': 'multipart/form-data', // Ensure multipart/form-data
        },
      };

      axios.post(`${adminMainUrl}/api/customer-profile/upload-disapproved-documents-again`, formData, config)
        .then(res => {
          if (res.status === 200) {

            toast.success(res.data.msg);
            setDisable(false);
            dispatch(getCustomerProfileDocumentList());
          } else {
            toast.error(res.data.msg);
            setDisable(false);
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response) {
            toast.error(err.response.data.msg);
          } else {
            toast.error("Internal server error.");
          }
          setDisable(false);
        });

    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.msg || "An error occurred.");
      setDisable(false);
    }
  };

  const currentItems = CustomerProfileDocumentList
  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Document Name", dataIndex: "documentName", key: "documentName" },
    { title: "File", dataIndex: "image", key: "image" },
    // { title: "Approval", dataIndex: "Approval", key: "Approval" },
  ];

  // Generate the dataSource and check if any entry has 'DISAPPROVED'
  let showDisapprovalReason = false;
  const dataSource = currentData?.map((value, i) => {
    if (value.approval === 'DISAPPROVED') {
      showDisapprovalReason = true;
    }
    return {
      key: i,
      SNo: i + 1,
      documentName: value?.documentName,
      image: (
        <><a className="icon-background" href={`${adminMainUrl}/${value?.image}`} target="blank" title="View File">
          <i className=" fa fa-eye"></i>
        </a><a className="icon-background" href={`${adminMainUrl}/${value?.image}`} download title="Download File">
            <i className=" fa fa-download"></i>
          </a></>
      ),
      // Approval: value?.approval,
      // disapprovalReason: value?.approval === 'DISAPPROVED' ? value?.disapprovalReason : null,
      // UploadAgain: (<>
      //   <i className="fa fa-upload" onClick={() => handleAddShow(value?.id)}></i>
      //   <input type="file"
      //     accept={JSON.parse(value?.doucumentFormat).join(",")}
      //     onChange={(e) => { handleChange(e, value?.id) }} />
      //   <button type="submit" className="btn btn-primary">Upload</button>
      // </>)
    };
  });

  // Add the Disapproval Reason column conditionally
  if (showDisapprovalReason) {
    columns.push({ title: "Disapproval Reason", dataIndex: "disapprovalReason", key: "disapprovalReason" });
    // columns.push({ title: "Upload Again", dataIndex: "UploadAgain", key: "UploadAgain" });
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {(CustomerProfileData && CustomerProfileData.profileCompleted && CustomerProfileData.approval == "DISAPPROVED") && <RejectionAlert reason={CustomerProfileData?.rejection_reason} />}
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Customer Documents<span className="count-title">{CustomerProfileDocumentList?.length}</span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-original-title="Collapse"
                        id="collapse-header"
                      >
                        <i className="ti ti-chevrons-up" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="card">

            <div className="card-body">

              {/* Contact List */}
              {
                loadingCustomerProfileDocumentListApi
                  ?
                  arr.map((value, index) => {
                    return (

                      <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                      </div>
                    )
                  }) :
                  spinnerLoader ?
                    <>
                      <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                      </div>
                    </> :
                    <>
                      <div className="table-responsive custom-table">
                        <Table className="table datanew dataTable no-footer" pagination={false}
                          dataSource={dataSource} columns={columns} />
                      </div>

                      <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                    </>
              }
              {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
      <DisapprovedDocUpload show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} id={id} />

    </>

  )
}

export default CustomerProfileDocumentationList